// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  name: __t.string(),
  createdByName: __t.string().name("created_by_name"),
  createdAt: __t.timestamp().name("created_at"),
  clipCount: __t.u32().name("clip_count"),
  durationUs: __t.f64().name("duration_us"),
  number: __t.u32(),
  kind: __t.string(),
  jobId: __t.string().name("job_id"),
  scopeId: __t.string().name("scope_id"),
});
